module.exports = __webpack_public_path__ + "packs/media/images/palestraSoci-3e2be79432cc399c1f9fd07acb2941db.jpg";